import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Utils } from 'core/utils';

const ICONS_BY_FOLDER = {
  'common': ['checkmark', 'close', 'toast'],
  'design-step': ['designs', 'photos', 'text'],
  'gallery': ['delete', 'eye-close', 'eye-open', 'photo-upload'],
  'image-editing': [
      'crop', 'glass-minus', 'glass-plus', 'photo-remove', 'replace',
      'rotate', 'rotate-left', 'rotate-left-90', 'rotate-right',
      'rotate-right-90'],
  'overlays': ['duplicate', 'remove', 'text-editing'],
  'quality-rating': ['bad', 'good', 'info', 'medium'],
  'template-chooser': ['view-grid', 'view-single'],
  'text-edit-toolbox': ['empty-text', 'text-add', 'text-delete', 'text-edit'],
  'text-editing': [
      'align-center', 'align-left', 'align-right', 'bg-colors', 'colors',
      'clear-text', 'contrast-info',
      'effect-allcaps', 'effect-bold', 'effect-italic',
      'effect-strikethrough', 'effect-underline', 'effects', 'font-size',
      'fonts'],
  'top-bar': [
      'arrow-back', 'arrow-forward', 'arrow-left', 'caret-down', 'logo-small'],
} as const;

type IconFolder = keyof typeof ICONS_BY_FOLDER;
export type IconName = typeof ICONS_BY_FOLDER[IconFolder][number];

const FOLDER_BY_ICON = new Map<IconName, IconFolder>(
    (Object.keys(ICONS_BY_FOLDER) as Array<IconFolder>).flatMap(
        folder => ICONS_BY_FOLDER[folder].map(
            name => [name, folder] as [IconName, IconFolder])));

export namespace Icons
{
  export function url(name: IconName): string
  {
    return Utils.url(
        `./assets/img/icons/${FOLDER_BY_ICON.get(name)}/${name}.svg`);
  }

  export function registerAll(
      mir: MatIconRegistry, sanitizer: DomSanitizer): void
  {
    for (const name of FOLDER_BY_ICON.keys()) {
      mir.addSvgIcon(
          name, sanitizer.bypassSecurityTrustResourceUrl(url(name)));
    }
  }
}
